export function getFrameworkId(): string {
  return 'bootstrap3';
}
export { default as Bootstrap3Renderer, default } from './Bootstrap3Renderer.js';
